import React, { useContext } from 'react';
import { Auth } from 'aws-amplify';

import { AuthenticatorContext } from './AuthenticatorContext';
import {
   AuthenticatorButton,
   AuthenticatorForm,
   AuthenticatorInput,
   AuthenticatorSubmitButton,
} from './AuthenticatorForm';

const LogIn = () => {
   const { dispatch } = useContext(AuthenticatorContext);
   return (
      <AuthenticatorForm
         heading="Log In"
         onSubmit={(formData) =>
            Auth.signIn(formData.get('email'), formData.get('password')).then(
               (res) => {
                  if (res?.challengeName === 'NEW_PASSWORD_REQUIRED') {
                     dispatch({
                        type: 'changeView',
                        view: 'setNewPassword',
                        userData: {
                           userObject: res,
                           needsName:
                              res?.challengeParam?.requiredAttributes?.[0] ===
                              'name',
                        },
                     });
                  }
               }
            )
         }
      >
         <AuthenticatorInput
            name="email"
            type="email"
            autoComplete="email"
            placeholder="Email"
            required
            autoFocus
         />
         <AuthenticatorInput
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="Password"
            required
         />
         <AuthenticatorButton
            className="button-dismiss button-forgot-password"
            onClick={() =>
               dispatch({ type: 'changeView', view: 'forgotPassword' })
            }
         >
            Forgot Password?
         </AuthenticatorButton>
         <AuthenticatorSubmitButton>Log In</AuthenticatorSubmitButton>
         <p>
            Need an account?{' '}
            <AuthenticatorButton
               className="button-link"
               onClick={() => dispatch({ type: 'changeView', view: 'signUp' })}
            >
               Sign Up
            </AuthenticatorButton>
         </p>
      </AuthenticatorForm>
   );
};

export { LogIn };
